import React from 'react';
import VectorSearch from '../components/VectorSearch';
import Chatbot from '../components/Chatbot';

const AiToolsPage = () => {
    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-6">AI Tools</h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div>
                    <VectorSearch />
                </div>
                <div>
                    <Chatbot />
                </div>
            </div>
        </div>
    );
};

export default AiToolsPage;
